import { useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

import { formatCurrency } from '../../utilities/helpers'
import { getMonthSeries } from './accountingReportView'

const COLLECTED_COLOR = '#45b36b'
const OWED_COLOR = '#ffd166'

const compactCurrency = (value) => {
  const amount = Number(value || 0)
  if (Math.abs(amount) >= 1000) {
    return `$${Math.round(amount / 1000)}k`
  }
  return formatCurrency(amount)
}

export default function AccountingMonthChart({ report }) {
  const options = useMemo(() => {
    const series = getMonthSeries(report)

    return {
      chart: {
        type: 'column',
        height: 320,
        backgroundColor: 'transparent',
        spacing: [28, 8, 8, 8],
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: {
        align: 'left',
        verticalAlign: 'top',
        symbolRadius: 2,
        itemStyle: {
          color: 'rgba(158, 178, 218, 0.92)',
          fontWeight: '500',
          fontSize: '12px',
        },
      },
      xAxis: {
        categories: series.categories,
        lineColor: 'rgba(112, 143, 212, 0.28)',
        tickColor: 'transparent',
        labels: {
          style: { color: 'rgba(158, 178, 218, 0.88)', fontSize: '12px' },
        },
      },
      yAxis: {
        min: 0,
        title: { text: null },
        gridLineColor: 'rgba(106, 139, 206, 0.16)',
        labels: { enabled: false },
        stackLabels: {
          enabled: true,
          formatter() {
            return compactCurrency(this.total)
          },
          style: {
            color: 'rgba(234, 244, 255, 0.88)',
            fontWeight: '600',
            textOutline: 'none',
          },
        },
      },
      tooltip: {
        shared: true,
        backgroundColor: 'rgba(8, 15, 40, 0.96)',
        borderColor: 'rgba(76, 109, 185, 0.4)',
        style: { color: 'rgba(234, 244, 255, 0.96)' },
        formatter() {
          const points = this.points || []
          const total = points.reduce((sum, point) => sum + point.y, 0)
          const rows = points
            .map(
              (point) =>
                `<span style="color:${point.color}">\u25A0</span> ${
                  point.series.name
                }: <b>${formatCurrency(point.y)}</b>`
            )
            .join('<br/>')
          return `<b>${this.x}</b><br/>${rows}<br/>Total: <b>${formatCurrency(
            total
          )}</b>`
        },
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          borderWidth: 0,
          borderRadius: 3,
          pointPadding: 0.18,
          groupPadding: 0.12,
        },
      },
      series: [
        {
          name: 'Collected (card)',
          data: series.collected,
          color: COLLECTED_COLOR,
        },
        {
          name: 'Owed (non-card)',
          data: series.owed,
          color: OWED_COLOR,
        },
      ],
    }
  }, [report])

  if (!report?.months?.length) {
    return (
      <p className="text-muted small mb-0">
        No monthly service fee activity for this range.
      </p>
    )
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}
